import FJObjectEraseLeft from '../view/FJObjectEraseLeft';
import useLocalStore from '../../../../hooks/useLocalStore';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import FJActionObjectErase from '../../../../redux/action/FJActionObjectErase';

const FJObjectEraseLeftContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();

    const curMenuIndex = useSelector(state => state.objectErase.curMenuIndex);

    const switchCurMenuIndex = useCallback(
        index => {
            dispatch(FJActionObjectErase.changeCurMenuIndexAction(index));
        },
        [dispatch],
    );

    return <FJObjectEraseLeft curMenuIndex={curMenuIndex} switchCurMenuIndex={switchCurMenuIndex} />;
};

export default FJObjectEraseLeftContainer;
